// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1ji5P","messages":"Chat_messages__2WyKK","dateDivider":"Chat_dateDivider__nqVR4"};